import store from '../../../store/sellsyaccountmanager/catalog';

export default {
    created() {
        // Init store
        this.$store.registerModule('catalog', store);
    },
}